import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X, Phone } from 'lucide-react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/529984830209?text=Hola, me gustaría solicitar una cotización para rentar un inflable', '_blank');
  };

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-white/80 backdrop-blur-sm'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <a href="https://www.happyrentalcancun.com/">
            <div className="flex-shrink-0 cursor-pointer" >
              <img style={{ width: "160px" }} src="img/hay.png" alt="" />
            </div>
            </a>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <button onClick={() => scrollToSection('servicios')} className="text-gray-700 hover:text-blue-600 font-medium transition-colors">
                Servicios
              </button>
              <button onClick={() => scrollToSection('catalogo')} className="text-gray-700 hover:text-blue-600 font-medium transition-colors">
                Catálogo
              </button>
              <button onClick={() => scrollToSection('testimonios')} className="text-gray-700 hover:text-blue-600 font-medium transition-colors">
                Testimonios
              </button>
              <button onClick={() => scrollToSection('contacto')} className="text-gray-700 hover:text-blue-600 font-medium transition-colors">
                Contacto
              </button>
              <Button 
                onClick={handleWhatsAppClick}
                className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white shadow-lg"
              >
                <Phone className="w-4 h-4 mr-2" />
                Cotizar Ahora
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100">
            <div className="px-4 py-6 space-y-4">
              <button onClick={() => scrollToSection('servicios')} className="block w-full text-left text-gray-700 hover:text-blue-600 font-medium py-2">
                Servicios
              </button>
              <button onClick={() => scrollToSection('catalogo')} className="block w-full text-left text-gray-700 hover:text-blue-600 font-medium py-2">
                Catálogo
              </button>
              <button onClick={() => scrollToSection('testimonios')} className="block w-full text-left text-gray-700 hover:text-blue-600 font-medium py-2">
                Testimonios
              </button>
              <button onClick={() => scrollToSection('contacto')} className="block w-full text-left text-gray-700 hover:text-blue-600 font-medium py-2">
                Contacto
              </button>
              <Button 
                onClick={handleWhatsAppClick}
                className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white"
              >
                <Phone className="w-4 h-4 mr-2" />
                Cotizar Ahora
              </Button>
            </div>
          </div>
        )}
      </nav>
      {/* Spacer to prevent content from going under fixed navbar */}
      <div className="h-20"></div>
    </>
  );
};

export default Navbar;
